<app-public-cart-quantity
  (quantityChangeEvent)="handleQuantityChange($event)"
  [disabled]="disabled()"
  [quantity]="quantity()" />
